import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { showToast } from 'utils/utility';
import { usePagination } from 'hook/usePagination';
import { useAdminAccountsData } from 'libs/data-access';
import { IAffiliatePaymentRequestResponse } from 'libs/data-access/types';

const useAffiliatePaymentRequest = () => {

    const navigate = useNavigate();

    const {
        getAdminAccountsData,
        patchAdminAccountsData
    } = useAdminAccountsData();


    const [paymentRequestStatus, setPaymentRequestStatus] = useState<"PENDING" | "APPROVED" | "REJECTED">("PENDING");
    const [selectedPaymentRequest, setSelectedPaymentRequest] = useState<{
        data: IAffiliatePaymentRequestResponse | null;
        formData: {
            status: "PENDING" | "APPROVED" | "REJECTED";
            remark: string | null;
        };
        isSaving: boolean;
    }>({
        data: null,
        formData: {
            status: "PENDING",
            remark: null
        },
        isSaving: false
    });


    const {
        dataList: paymentRequest,
        // setDataList,
        isLoading,
        // setSearchText,
        // searchText,
        goToNextPage,
        goToPreviousPage,
        disablePrev,
        disableNext,
        // initialLoading,
        // setTriggerNextPage,
        // setTriggerPreviousPage,
        refreshPagination
    } = usePagination<IAffiliatePaymentRequestResponse>({
        fetchListData: getAdminAccountsData,
        maxLimit: 50,
        sortby: "DESC",
        // sortingOrder: sortingDetails?.sortingOrder,
        extraQueryParams: {
            status: paymentRequestStatus
        },
        // paginationParams: paginationQueryParams as Record<string, string | number | boolean>,
        dependencies: [paymentRequestStatus]
    });


    // API CALLS
    const updatePaymentRequestStatus = async () => {

        if (!selectedPaymentRequest.data?.id) {
            showToast({
                type: "warning",
                message: "Please select a payment request to update status!"
            });
            return;
        };

        if (!selectedPaymentRequest.formData.status) {
            showToast({
                type: "warning",
                message: "Please select a status!"
            });
            return;
        };

        setSelectedPaymentRequest(prev => ({
            ...prev,
            isSaving: true
        }));

        const payload = {
            id: selectedPaymentRequest.data?.id,
            status: selectedPaymentRequest.formData.status,
            remark: selectedPaymentRequest.formData.remark
        };

        const response = await patchAdminAccountsData(`/change-status`, payload);

        if (response.isSuccess) {
            // console.log("Response for updating payment request status: ", response);
            refreshPagination();
            setSelectedPaymentRequest({
                data: null,
                formData: {
                    status: "PENDING",
                    remark: null
                },
                isSaving: false
            });
        } else {
            console.log("Error while updating payment request status: ", response);
            showToast({
                type: "error",
                message: response.message || "Error while updating payment request status"
            });
        };

        setSelectedPaymentRequest(prev => ({
            ...prev,
            isSaving: true
        }));

    };


    return {
        isLoading,
        paymentRequest,
        navigate,
        goToNextPage,
        goToPreviousPage,
        disablePrev,
        disableNext,
        paymentRequestStatus,
        setPaymentRequestStatus,
        selectedPaymentRequest,
        setSelectedPaymentRequest,
        updatePaymentRequestStatus
    };

};

export default useAffiliatePaymentRequest;